module.exports = __webpack_public_path__ + "img/icon-merck.731efc9f.svg";